// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NestedAccordPart_wrapper__3Vywk","netWrapper":"NestedAccordPart_netWrapper__3Twq4"};